import Badge from "@visa/vds/badge";
import React from "react";

const OrderStatus = (props) => {
  const renderType = () => {
    switch (props.order.orderStatus) {
      case 0:
        return <Badge type="warning">{props.order.orderStatusName}</Badge>;
      case 1:
        return <Badge type="stable">{props.order.orderStatusName}</Badge>;
      case 2:
        return <Badge type="critical">{props.order.orderStatusName}</Badge>;
    }
  };
  return <>{renderType()}</>;
};

export default OrderStatus;
